export default {
	TABLE_TITLE: 'Product recommendations product variants',
	PRODUCT_RECOMMENDATION_PRODUCT_VARIANT_ADDED:
		'Product recommendation product variant added',
	PRODUCT_RECOMMENDATION_PRODUCT_VARIANT_DELETED:
		'Product recommendation product variant deleted'
};
